export default "__VITE_ASSET__BjOkynHq__"